export const userColumns = [
  // { field: "id", headerName: "ID", width: 230 },
  {
    field: "userName",
    headerName: "Usuario",
    width: 100,

  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },
  {
    field: "firstName",
    headerName: "Nombre",
    width: 100,
  },
  {
    field: "lastName",
    headerName: "Apellido",
    width: 150,
  },
  {
    field: "banned",
    headerName: "Baneado",
    width: 100,
  },

  
  // {
  //   field: "status",
  //   headerName: "Estado",
  //   width: 160,
  //   renderCell: (params) => {
  //     return (
  //       <div className={`cellWithStatus ${params.row.status}`}>
  //         {params.row.status}
  //       </div>
  //     );
  //   },
  // },
];
